import Plausible, { type EventOptions, type PlausibleOptions } from 'plausible-tracker'

const options = {
  domain: 'tester-club.outfit7.com',
  hashMode: true,
  trackLocalhost: false
}

let trackEvent: (eventName: string, options?: EventOptions, eventData?: PlausibleOptions) => void

if (import.meta.client) {
  const { enableAutoPageviews, trackEvent: track } = Plausible(options)
  trackEvent = track
  enableAutoPageviews()
}

export function usePlausible() {
  return {
    trackEvent
  }
}
